import { render, staticRenderFns } from "./AdUnitTitle.vue?vue&type=template&id=b84dd6a2&scoped=true&"
import script from "./AdUnitTitle.vue?vue&type=script&lang=js&"
export * from "./AdUnitTitle.vue?vue&type=script&lang=js&"
import style0 from "./AdUnitTitle.vue?vue&type=style&index=0&id=b84dd6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84dd6a2",
  null
  
)

export default component.exports